import { BaseModel } from 'paliari-js-utils'
import Endereco from './Endereco'

const attributes = {
  id: null,
  celular: '',
  cpf_cnpj: '',
  email: '',
  fone: '',
  nome_contato: '',
  nome_fantasia: '',
  razao_social: '',
  inscricao_estadual: '',
  site: '',
  rg: '',
  rg_orgao_emissor: '',
  rg_emissao: null,
  rg_uf: '',
  crc: '',
  crea: '',
  cau: '',
  modulo_ids: [],
  endereco: obj => new Endereco(obj),
  contribuinte: obj => ({ ...obj }),
}

class Pessoa extends BaseModel {
  constructor(obj) {
    super(attributes, obj)
  }
}

export default Pessoa
